import React, { useCallback, ChangeEventHandler } from 'react';
import parseISO from 'date-fns/parseISO';
import formatISO from 'date-fns/formatISO';

import { DateType } from '../../../../../types';

interface UniversalFilterDateInputProps {
  value?: DateType;
  autoFocus?: boolean;
  onChange: (value?: string) => void;
}

function UniversalFilterDateInput({
  value,
  autoFocus,
  onChange
}: UniversalFilterDateInputProps) {
  const handleChange = useCallback<ChangeEventHandler<HTMLInputElement>>(
    (event) => {
      const localStartOfDay = parseISO(event?.target?.value).toJSON();
      onChange(localStartOfDay);
    },
    [onChange]
  );

  const inputValue = value
    ? formatISO(new Date(value), { representation: 'date' })
    : null;

  return (
    <div className="flex-1">
      <div className="relative">
        <input
          className="basic-input"
          type="date"
          value={inputValue || ''}
          autoFocus={autoFocus}
          onChange={handleChange}
        />
      </div>
    </div>
  );
}

export default UniversalFilterDateInput;
